import React from 'react';
import PropTypes from 'prop-types';

const InformacionPago = ({ informacionPago }) => {
    const getFormaPagoStyle = (formaPago) => {
        if (!formaPago) return {};
        
        const formasElectronicas = ['03', '04', '28', '29', '05'];
        const codigo = formaPago.substring(0, 2);
        const isElectronica = formasElectronicas.includes(codigo);
        return {
            color: isElectronica ? '#198754' : '#dc3545',
            fontWeight: '600'
        };
    };

    return (
        <div className="mb-4">
            <h6 className="fw-bold mb-3 border-bottom pb-2 text-uppercase text-secondary">
                INFORMACIÓN DEL PAGO
            </h6>
            
            <div className="table-responsive border rounded bg-white shadow-sm">
                <table className="table table-bordered table-sm table-hover mb-0" style={{ fontSize: '0.85rem' }}>
                    <tbody>
                        <tr>
                            <th className="table-light w-25 align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Fecha de pago:</th>
                            <td className="align-middle w-25">{informacionPago?.fechaPago || '-'}</td>
                            <th className="table-light w-25 align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Forma de pago:</th>
                            <td className="align-middle w-25" style={getFormaPagoStyle(informacionPago?.formaDePagoP)}>
                                {informacionPago?.formaDePagoP || '-'}
                            </td>
                        </tr>
                        <tr>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Moneda Pago:</th>
                            <td className="align-middle">{informacionPago?.monedaP || '-'}</td>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Versión Pagos:</th>
                            <td className="align-middle">{informacionPago?.versionPagos || '-'}</td>
                        </tr>
                        <tr>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Monto Total Pagos:</th>
                            <td className="align-middle">${informacionPago?.montoTotalPagos || '0.00'}</td>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>TotalTrasladoBaseIVA16:</th>
                            <td className="align-middle">${informacionPago?.totalTrasladoBaseIVA16 || '0.00'}</td>
                        </tr>
                        <tr>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>TotalTrasladoImpuestoIVA16:</th>
                            <td className="align-middle">${informacionPago?.totalTrasladosImpuestoIVA16 || '0.00'}</td>
                            <th className="table-light align-middle text-muted fw-bold" style={{ fontSize: '0.75rem' }}>Monto:</th>
                            <td className="align-middle fw-bold">
                                ${informacionPago?.monto || '0.00'}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

InformacionPago.propTypes = {
    informacionPago: PropTypes.shape({
        versionPagos: PropTypes.string,
        montoTotalPagos: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        totalTrasladoBaseIVA16: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        totalTrasladosImpuestoIVA16: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        fechaPago: PropTypes.string,
        formaDePagoP: PropTypes.string,
        monedaP: PropTypes.string,
        monto: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
};

export default InformacionPago;
